import { Badge, Flex, Tag, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { ArrowRightShort } from "react-bootstrap-icons";

import { getDomainVisitorLabel } from "@/modules/Domains";
import { ExternalRedirectTargetType, ExternalRedirectsListTableDataObj, getExternalRedirectTargetDomainTagColor } from "@/modules/ExternalRedirects";
import { getRedirectMatchModeLabel } from "@/modules/Sites";

export const columns: ColumnsType<ExternalRedirectsListTableDataObj> = [
  {
    title: 'Стан',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 24,
    render: (isActive: ExternalRedirectsListTableDataObj['isActive']) => (
      <Badge status={ isActive ? 'success' : 'default' } style={{ transform: 'scale(1.3)' }} />
    ),
  },
  {
    title: 'Джерело',
    dataIndex: 'sourceDomainLabel',
    key: 'sourceDomainLabel',
    render: (sourceDomainLabel: ExternalRedirectsListTableDataObj['sourceDomainLabel'], record) => (
      <Flex gap={ 6 } align="center" wrap>
        <Tag color="geekblue">{ sourceDomainLabel }</Tag>
        <Typography.Text type="secondary">{ record.sourceEndpointLabel }</Typography.Text>
      </Flex>
    ),
  },
  {
    key: 'arrow',
    width: 24,
    render: () => <ArrowRightShort size={ 18 }/>,
  },
  {
    title: 'Ціль',
    dataIndex: 'toType',
    key: 'toType',
    render: (toType: ExternalRedirectsListTableDataObj['toType'], record) => (
      <Flex gap={ 6 } align="center" wrap>
        <Tag color={ getExternalRedirectTargetDomainTagColor(toType) }>
          { toType === ExternalRedirectTargetType.Site
            ? `Сайт: ${ record.targetDomainLabel || '—' }`
            : (record.targetDomainLabel || '—') }
        </Tag>
        <Typography.Text type="secondary">{ record.targetEndpointLabel }</Typography.Text>
      </Flex>
    ),
  },
  {
    title: 'Режим',
    dataIndex: 'matchMode',
    key: 'matchMode',
    width: 130,
    render: (matchMode: ExternalRedirectsListTableDataObj['matchMode']) => <Tag color="purple">{ getRedirectMatchModeLabel(matchMode) }</Tag>,
  },
  {
    title: 'Код',
    dataIndex: 'statusCode',
    key: 'statusCode',
    width: 70,
    render: (statusCode: ExternalRedirectsListTableDataObj['statusCode']) => <Tag color="blue">{ statusCode }</Tag>,
  },
  {
    title: 'Для відвідувача',
    dataIndex: 'forVisitor',
    key: 'forVisitor',
    width: 110,
    render: (forVisitor: ExternalRedirectsListTableDataObj['forVisitor']) => <Tag color="geekblue">{ getDomainVisitorLabel(forVisitor) }</Tag>,
  },
]